/*
Three states:

  0 = auth required && auth failed
  1 = auth required && auth succeeded
  -1 = auth not required so we're all good
*/

export function authZ(user, { action, actions, role, roles }) {
  if (action || actions || role || roles) {
    if (
      (action && !user.canGlobally(action)) ||
      (actions && !user.canGloballyAny(actions)) ||
      (role && !user.is(role)) ||
      (roles && !user.isAny(roles))
    ) {
      return 0
    }
    return 1
  }
  return -1
}

export function isAuthZ(user, opts) {
  return !!authZ(user, opts)
}
